import { APP_MENU_ITEMS, NAVIGATION_MENU_ITEMS } from './constants';
import { USER_ROLES } from '../auth/roles';
import type { UserRole } from '../auth/types';

type AppMenuItem = (typeof APP_MENU_ITEMS)[keyof typeof APP_MENU_ITEMS];

type NavigationMenuItem =
  (typeof NAVIGATION_MENU_ITEMS)[keyof typeof NAVIGATION_MENU_ITEMS];

export const ROLE_NAVIGATION_MAP: Record<
  UserRole,
  Partial<
    Record<
      (typeof APP_MENU_ITEMS)[keyof typeof APP_MENU_ITEMS]['id'],
      NavigationMenuItem[]
    >
  >
> = {
  [USER_ROLES.AdminAbbott]: {
    [APP_MENU_ITEMS.AbbottAdministration.id]: [
      NAVIGATION_MENU_ITEMS.AbbottUserAdministration,
      NAVIGATION_MENU_ITEMS.AbbottAdminArchive,
    ],
    [APP_MENU_ITEMS.CustomerAdministration.id]: [
      NAVIGATION_MENU_ITEMS.IDNS,
      NAVIGATION_MENU_ITEMS.Departments,
      NAVIGATION_MENU_ITEMS.CustomerUserAdministration,
      NAVIGATION_MENU_ITEMS.PatientsCustomerAdministration,
    ],
    [APP_MENU_ITEMS.Education.id]: [], // TODO
  },
  [USER_ROLES.AbbottUser]: {
    [APP_MENU_ITEMS.CustomerAdministration.id]: [
      NAVIGATION_MENU_ITEMS.IDNS,
      NAVIGATION_MENU_ITEMS.Departments,
      NAVIGATION_MENU_ITEMS.UserAdministration,
      NAVIGATION_MENU_ITEMS.PatientsCustomerAdministration,
    ],
    [APP_MENU_ITEMS.Education.id]: [], // TODO
  },
  [USER_ROLES.HcpAdmin]: {
    [APP_MENU_ITEMS.Administration.id]: [
      NAVIGATION_MENU_ITEMS.UserAdministration,
      NAVIGATION_MENU_ITEMS.DepartmentsAndSettings,
      NAVIGATION_MENU_ITEMS.Archive,
    ],
    [APP_MENU_ITEMS.Outpatient.id]: [
      NAVIGATION_MENU_ITEMS.PatientAdministration,
      NAVIGATION_MENU_ITEMS.PatientAdministrationArchive,
    ],
    [APP_MENU_ITEMS.Education.id]: [], // TODO
  },
  [USER_ROLES.HcpUser]: {
    [APP_MENU_ITEMS.Outpatient.id]: [
      NAVIGATION_MENU_ITEMS.PatientAdministration,
      NAVIGATION_MENU_ITEMS.PatientAdministrationArchive,
    ],
    [APP_MENU_ITEMS.Education.id]: [], // TODO
  },
  [USER_ROLES.NonHcpAdmin]: {
    [APP_MENU_ITEMS.Administration.id]: [
      NAVIGATION_MENU_ITEMS.UserAdministration,
      NAVIGATION_MENU_ITEMS.DepartmentsAndSettings,
      NAVIGATION_MENU_ITEMS.Archive,
    ],
    [APP_MENU_ITEMS.Education.id]: [], // TODO
  },
};

export const getAppMenuItemsByRole = (
  role: UserRole | undefined,
): AppMenuItem[] => {
  switch (role) {
    case USER_ROLES.AdminAbbott:
      return [
        APP_MENU_ITEMS.AbbottAdministration,
        APP_MENU_ITEMS.CustomerAdministration,
        APP_MENU_ITEMS.Education,
      ];
    case USER_ROLES.AbbottUser:
      return [APP_MENU_ITEMS.CustomerAdministration, APP_MENU_ITEMS.Education];
    case USER_ROLES.HcpAdmin:
      return [
        APP_MENU_ITEMS.Administration,
        APP_MENU_ITEMS.Outpatient,
        APP_MENU_ITEMS.Education,
      ];
    case USER_ROLES.HcpUser:
      return [APP_MENU_ITEMS.Outpatient, APP_MENU_ITEMS.Education];
    case USER_ROLES.NonHcpAdmin:
      return [APP_MENU_ITEMS.Administration, APP_MENU_ITEMS.Education];
    default:
      return [];
  }
};

export const getIndexNavigationPathByRole = (role: UserRole | undefined) => {
  const defaultAppMenuItemId = getAppMenuItemsByRole(role)[0]?.id;

  if (!role || !defaultAppMenuItemId) {
    return '/';
  }

  const items = ROLE_NAVIGATION_MAP[role][defaultAppMenuItemId] ?? [];
  const defaultNavigationItemPath = items[0]?.path;

  return defaultNavigationItemPath;
};
